import { useEffect, useMemo } from 'react';
import {
  callWorkerWithCleanup,
  WorkerAPI,
} from 'utils/call-worker-with-cleanup';

export function useWorker(): WorkerAPI {
  const workerApiAndCleanup = useMemo(() => callWorkerWithCleanup(), []);

  useEffect(() => {
    return () => workerApiAndCleanup.cleanup();
  }, [workerApiAndCleanup]);

  return workerApiAndCleanup;
}
